import { LiveSessionsList } from '@crehana/compass.live-sessions';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';
import dynamic from 'next/dynamic';

const LazyLiveSessionsSection = dynamic(() => import('./LiveSessionsSection'), {
  loading: () => (
    <div className="tw-w-full tw-mb-8">
      <Container type={'dashboard'}>
        <LiveSessionsList
          sessions={[]}
          variant="past"
          error={false}
          // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
          onRefresh={() => {}}
          searchFilter={''}
          organizationSlug=""
          isAdmin={false}
          loading={true}
        />
      </Container>
    </div>
  ),
});

export default LazyLiveSessionsSection;
